import { render } from "./StakeholderEditModal.vue?vue&type=template&id=091181ae&scoped=true"
import script from "./StakeholderEditModal.vue?vue&type=script&lang=js"
export * from "./StakeholderEditModal.vue?vue&type=script&lang=js"

import "./StakeholderEditModal.vue?vue&type=style&index=0&id=091181ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091181ae"]])

export default __exports__